export default function (instance) {
  return {
    getInvoiceAll () {
      return instance
        .get('/api/invoice/list')
        .then(response => response.data)
    },

    getInvoiceFileById (id) {
      return instance
        .get(`/api/attachment/invoicefile/${id}`, {
        })
        .then(response => response.data)
    }
  }
}
